// Static site data for ESS BEE HEATERS PVT. LTD.

export const COMPANY = {
  oldName: "ESS BEE ELECTRICAL",
  newName: "ESS BEE HEATERS PVT. LTD.",
  changeYear: 2017,
  since: 2000,
  yearsExcellence: "25+",
  tagline: "Quality is our Tradition",
  description:
    "Leading manufacturer of Industrial Heaters & Heating Elements — Tubular Heaters, Air Heaters, Infrared Heaters (Shortwave IR, Ceramic IR, MediumWave IR), Cartridge Heaters, Mica Band Heaters, Ceramic Band Heaters, Immersion Heaters and more. Trusted by 1000+ clients across India since 2000.",
  aboutLong:
    "We are a trusted and pioneering manufacturer of Commercial & Industrial Heaters and Heating Elements, delivering high-performance heating solutions powered by advanced technology and decades of technical expertise. Our focus on innovation, efficiency, and reliability has made us a preferred partner for customers seeking consistent performance and long service life for their equipment and machinery.",
  aboutLong2:
    "Our extensive product range includes commercial heating elements for hotel appliances, industrial immersion heaters for oil, water and chemical applications, cartridge heaters for moulds and dies, coil and manifold heaters for hot runner moulds, tubular and finned air heaters, casted heating units, and mica & ceramic band heaters. Each product is engineered for maximum thermal efficiency and can be custom-designed to meet specific operational requirements.",
  logo: "/brand/logo.png",
  heroBanner: "/brand/hero-banner.jpg",
  videoId: "csjwGW3j2RU",
  contacts: [
    { name: "Mr. Hrithik Bansal", role: "Main Contact", phone: "+91-9911565091", whatsapp: "919911565091" },
    { name: "Mr. Sunil Bansal", role: "Director", phone: "+91-9911565090", whatsapp: "919911565090" },
  ],
  emails: ["ess_beeheat@yahoo.com", "sunilbansal151@gmail.com"],
  address:
    "Kh. No. 22/6/01, Gali No., Pipal Wali Gali, Samay Pur Extn. Industrial Area, Delhi - 110042, India",
  catalogueUrl: "/brand/catalogue.pdf",
};

export const BADGES = [
  "ISO 9001:2015 Certified",
  "RoHS Compliant",
  "CE Certified",
  "Made in India",
  "25+ Years of Excellence",
  "OEM & Custom Solutions",
  "In-House R&D Lab",
  "Pan India Delivery",
];

export const CERTS = [
  { title: "ISO 9001:2015", sub: "Quality Management" },
  { title: "RoHS Compliant", sub: "Environment Safe" },
  { title: "CE Marked", sub: "European Standards" },
  { title: "MSME Registered", sub: "Govt. of India" },
];

export const STATS = [
  { value: "25+", label: "Years of Excellence" },
  { value: "1000+", label: "Happy Clients" },
  { value: "30+", label: "Product Range" },
  { value: "100%", label: "Quality Assurance" },
];

export const INDUSTRIES = [
  "OEMs",
  "Food Processing",
  "Textiles",
  "Plastic Industry",
  "Rubber Industry",
  "Chemical & Pharmaceutical",
  "Electroplating",
  "Fertilizer Plants",
  "PET Industries",
  "Foam Plants",
  "Cooler Honey Pad",
  "Packaging Industries",
];

export const PRODUCTS = [
  {
    name: "Shortwave IR Heater",
    img: "/products/shortwave-ir-heater.jpg",
    desc: "High-intensity infrared heater with rapid response time, ideal for drying, curing & high-temperature surface heating in industrial lines.",
  },
  {
    name: "Ceramic IR Heaters",
    img: "/products/ceramic-ir-heaters.jpg",
    desc: "Robust ceramic-bodied infrared emitters delivering uniform medium-wave radiation for thermoforming, paint baking and plastic welding.",
  },
  {
    name: "Hot Air Gun Heaters",
    img: "/products/hot-air-gun-heaters.jpg",
    desc: "Compact coil-type heating elements for hot air guns used in shrink-wrapping, soldering, and surface finishing applications.",
  },
  {
    name: "Medium Wave IR / Quartz Silica Heaters",
    img: "/products/medium-wave-ir.jpg",
    desc: "Quartz-tube IR emitters balancing fast warm-up and deep penetration — perfect for textiles, printing and food processing.",
  },
  {
    name: "Main Fold Heaters",
    img: "/products/main-fold-heaters.jpg",
    desc: "Custom-designed manifold heaters engineered for hot runner mould systems with precise thermal profiles.",
  },
  {
    name: "Low Watt Density Cartridge Heaters",
    img: "/products/low-watt-cartridge.jpg",
    desc: "Long-life cartridge heaters with reduced watt density for moulds, dies and platen heating up to medium temperatures.",
  },
  {
    name: "Mica Band Heaters",
    img: "/products/mica-band-heaters.jpg",
    desc: "Strapped mica band heaters for plastic extruders, injection moulding barrels and nozzles, with wide voltage range.",
  },
  {
    name: "Mini Space Heaters",
    img: "/products/mini-space-heaters.jpg",
    desc: "Compact panel heaters preventing condensation in electrical enclosures, control panels and outdoor cabinets.",
  },
  {
    name: "Oil Immersion Heaters",
    img: "/products/oil-immersion-heaters.jpg",
    desc: "Flange / screw-plug heaters for thermic fluid, hydraulic and lubricating oil tanks with thermostat-ready sheath options.",
  },
  {
    name: "Quartz Box / Silica Box Heaters",
    img: "/products/quartz-box.jpg",
    desc: "Reflector-housed quartz emitters delivering focused radiant heat for tunnel ovens and PET stretch-blow moulding.",
  },
  {
    name: "Ring Type Heaters",
    img: "/products/ring-type-heaters.jpg",
    desc: "Circular tubular heaters tailored for nozzles, dies and round assemblies where uniform circumferential heat is required.",
  },
  {
    name: "Round Plate Immersion Heaters",
    img: "/products/round-plate-immersion.jpg",
    desc: "Flanged round-plate immersion heaters for boilers, hot water tanks and chemical baths with stainless / Incoloy sheaths.",
  },
  {
    name: "Sealed Nozzle Heater",
    img: "/products/sealed-nozzle-heater.jpg",
    desc: "Moisture-sealed coil nozzle heaters for hot runner systems offering precise tip temperature control.",
  },
  {
    name: "Shortwave IR Heaters with Reflector Box",
    img: "/products/shortwave-reflector-box.jpg",
    desc: "Pre-assembled IR units with anodised aluminium reflectors maximising radiant efficiency on production lines.",
  },
  {
    name: "High Watt Density Cartridge Heater",
    img: "/products/high-watt-cartridge.jpg",
    desc: "High-performance cartridge heaters with magnesium oxide insulation for demanding plastic and packaging applications.",
  },
  {
    name: "SIC Heating Elements",
    img: "/products/sic-heating-elements.jpg",
    desc: "Silicon Carbide elements rated up to 1600 °C for laboratory and high-temperature industrial furnaces.",
  },
  {
    name: "Water Immersion Heaters",
    img: "/products/water-immersion-heaters.jpg",
    desc: "Direct water immersion heaters for boilers, geysers and industrial water-heating tanks with safety thermostats.",
  },
  {
    name: "Tubular Heaters",
    img: "/products/tubular-heaters.jpg",
    desc: "Multi-bend tubular elements in stainless / copper sheaths — the workhorse of air, oil and water heating systems.",
  },
  {
    name: "Thread Burning Heaters",
    img: "/products/thread-burning-heaters.jpg",
    desc: "Precision heaters used in textile loom thread burning operations for clean, knot-free finishing.",
  },
  {
    name: "Tape Heaters",
    img: "/products/tape-heaters.jpg",
    desc: "Flexible mica-insulated heating tapes for wrap-around heating of pipes, drums and irregular surfaces.",
  },
];
